import React, { type JSX } from 'react';
import styles from './PageBackground.module.scss';
import Image from 'next/image';
import cx from 'classnames';
import { useIsArchonApp } from '@resources/js/contexts/useIsArchonApp';

export default function PageBackground({
  imageUrl,
  width,
  height,
  flip = false,
  withBreadcrumbs = false,
  alwaysShow = false,
}: {
  imageUrl: string;
  width: number;
  height: number;
  flip?: boolean;
  withBreadcrumbs?: boolean;
  alwaysShow?: boolean;
}): JSX.Element {
  const isArchonApp = useIsArchonApp();

  return (
    <div
      className={cx({
        [styles.wrapper]: true,
        [styles.wrapperWithBreadcrumbs]: withBreadcrumbs && !isArchonApp,
        [styles.wrapperAlwaysShow]: alwaysShow,
      })}
    >
      <Image
        src={imageUrl}
        alt=''
        className={flip ? styles.imageFlipped : ''}
        width={width}
        height={height}
      />
    </div>
  );
}
